var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.975746 0.167464C0.75289 -0.0553925 0.391177 -0.0553925 0.167464 0.167464C-0.0562496 0.39032 -0.0553925 0.752033 0.167464 0.975746L0.975746 0.167464ZM4.00059 4.00059L3.59688 4.4043C3.81973 4.62716 4.18145 4.62716 4.40516 4.4043L4.00059 4.00059ZM7.83286 0.975746C8.05571 0.75289 8.05571 0.391177 7.83286 0.167464C7.61 -0.0562496 7.24829 -0.0553925 7.02458 0.167464L7.83286 0.975746ZM0.167464 0.975746L3.59688 4.4043L4.4043 3.59602L0.975746 0.167464L0.167464 0.975746ZM4.4043 4.4043L7.83286 0.975746L7.02458 0.167464L3.59602 3.59602L4.4043 4.4043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).b4bb99a5f9feb98d29df345749e9cc22.svg";
export { ForwardRef as ReactComponent };